var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-overlay"},[_c('div',[_c('div',{staticClass:"loader"}),_c('span',{staticClass:"text"})])])
}]

export { render, staticRenderFns }